import { render } from "./m_header.vue?vue&type=template&id=225c17bf&scoped=true"
import script from "./m_header.vue?vue&type=script&lang=js"
export * from "./m_header.vue?vue&type=script&lang=js"

import "./m_header.vue?vue&type=style&index=0&id=225c17bf&scoped=true&lang=css"

import exportComponent from "D:\\code\\vifa官网\\vifa\\vifa-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-225c17bf"]])

export default __exports__